import { useSelector } from 'react-redux';

import { VisitsLayout } from './visits-layout';
import { VisitsPageV2 } from 'pages/visits-page-v2';
import { uiMetadata } from 'store/ui-metadata/selectors';

/**
 * Layout component that conditionally renders V1 or V2 visits layout
 * based on visitor_management_new_ui flag
 */
export const VisitsV2Layout = (): JSX.Element | null => {
  const metadata = useSelector(uiMetadata);
  const useNewUI = metadata?.ui_metadata?.visitor_management_new_ui === true;

  if (!metadata) {
    return null;
  }

  // Render V2 when flag is true, otherwise render V1
  return useNewUI ? <VisitsPageV2 /> : <VisitsLayout />;
};
